import { AxiosInstance } from 'axios';
import { from, Observable } from 'rxjs';
import { first, map } from 'rxjs/operators';
import NetworkRequestsService from 'external-services/network-requests-service/index';
import { IBooking, IResponse } from 'shared-types/index';
import DateUtilsService from 'external-services/date-utils-service';

const NS = 'StandbyListService';
const api: AxiosInstance = NetworkRequestsService.getGlobalAPI();

class StandbyListService {
  private APIBASE: string;
  private getAccountId: () => string;
  private getVenueId: () => number;


  setup(
    api: string,
    getAccountId: () => string,
    getVenueId: () => number,
  ): void {
    this.APIBASE = api;
    this.getAccountId = getAccountId;
    this.getVenueId = getVenueId;
  }

  beginStandbyPayment(bookingId: string, venueId: number): Observable<IResponse<string>> {
    return from(
      api.get(`${this.APIBASE}/bookings/venues/${venueId}/begin-standby-payment/${bookingId}`)
    );
  }

  upgradeStandbyList(booking: IBooking): Observable<number> {
    const timeWithoutTZ = DateUtilsService.dateToDateTimeStr(booking.time);
    const data = {
      ...booking,
      time: timeWithoutTZ,
    };

    return from(
      api.post(
        `${
          this.APIBASE
        }/restaurants/accounts/${this.getAccountId()}/venues/${this.getVenueId()}/upgrade-standby`,
        data
      )
    ).pipe(
      first(),
      map((response: IResponse<any>) => {
        // leaving this line here for easier breakpoint/debugging in dev tools
        return response.status;
      })
    );
  }

  getGenericErrorResponseMessaging(status: number): string {
    switch (status) {
      case 403:
        return 'Sorry, there seems to have been a problem authorizing your account.';

      case 400:
        return 'Sorry, there seems to have been a problem with either your account or booking id.';

      case 404:
        return `Sorry, your account id doesn't appear to match any of our records.`;

      case 408:
        return `Sorry, server took too long to respond (timeout).`;
    }

    return 'Sorry, an error has occurred.';
  }
}

// creates a singleton instance to export
const instance = new StandbyListService();
export default instance;
